// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{background-color:transparent;border:none;cursor:pointer;padding:0}button,input{font-family:inherit;font-size:1em;outline:none}.footer__wrapper{margin-top:56px}.footer__wrapper .logo img{height:200px}@media(min-width:1200px){.footer__wrapper{margin-top:96px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
